import Styles from './MembershipCard.module.scss'
import { SecretIdentity } from '../SecretIdentity/SecretIdentity'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'

const MembershipCard = () => {
  const { isMobile } = useResponsiveDesign()

  return (
    <>
      {!isMobile && (
        <div className={Styles.title}>
          <Heading level={3}>Membership Card</Heading>
        </div>
      )}
      <section>
        <SecretIdentity />
      </section>
    </>
  )
}

export { MembershipCard }
